export default __webpack_public_path__ + "static/media/Queen_of_diamonds.7b4436a2.svg";